import React from 'react'

import ExpirationErrorImg from 'images/dizzy_robot.svg'
import DealErrorTemplate from 'layouts/DealErrorTemplate'

import { track } from 'utils/trackingUtils'

const EXPIRED_HEADER = 'Oops! Something went wrong when trying to process your deal'
const EXPIRED_DESCRIPTION = 'Please reach out to your sales rep so we can get this sorted for you as soon as we can'

const DealErrorLayout = () => (
  <DealErrorTemplate
    splashImage={ExpirationErrorImg}
    header={EXPIRED_HEADER}
    description={EXPIRED_DESCRIPTION}
    onMounted={() => track('Deal Flow - Deal Error Page Hit')}/>
)

export default DealErrorLayout


// WEBPACK FOOTER //
// ./src/layouts/DealError/index.js